<template>

  <div class="boas-vindas h-screen flex flex-col justify-center items-center">

    <h1 class="sm:text-4xl md:text-6xl mt-4 font-black dourado">Olá {{userisloged.username}}!</h1>
    <p class="mt-8 md:mt-4 text-white sm:text-lg md:text-2xl text-center">Seja muito bem vinda ao nossa sistema de integração</p>

    <div class="mt-0 md:mt-10 mx-auto p-3 md:p-0 md:w-1/2">

      <p class="mt-8 md:mt-4 text-white sm:text-lg md:text-2xl text-center">Essa integração tem como objetivo fazer com que você conheça e entenda tudo sobre a WDC. Esperamos que essas informações lhe ajudem no dia a dia na nossa empresa. Leia tudo com atenção e, em caso de dúvidas, volte e leia tudo novamente. {{userisloged.name}}, nós da WDC estamos te esperando de braços abertos!</p>

      <h2 class="mt-8 text-white text-2xl md:font-black text-center">E ai está preparado?</h2>


    </div>

    <div class="flex md:my-10 mx-auto text-center text-white footer">
      <button class="btn-next roboto md:text-lg p-2 md:p-4 mx-2 md:mx-5 border-none" @click="goToSlides">VAMOS LA</button>
    </div>

  </div>

</template>

<script>
  import  novotopo from './Paginas/topo.vue'
  import  conteudotext from './Paginas/ConteudoTexto.vue'
  import  conteudovideo from './Paginas/ConteudoVideo.vue'
  import  footerintegracao from './Paginas/footer.vue'
  import  diferenciais from './Paginas/Diferenciais.vue'
  import  horarios from './Paginas/horarios.vue'

  import moduleIntegracao from "../../store/integracao/moduleIntegracao";

  // Base css
  import "@/assets/css/integracao.css";

  export default {
    name: "Main",
    components:{
      novotopo,
      conteudotext,
      footerintegracao,
      conteudovideo,
      diferenciais,
      horarios,
    },
    created() {
      if (!this.userisloged){
        this.$router.push({name:'novaintegracao-login'})
      }
      if (!moduleIntegracao.isRegistered) {
        this.$store.registerModule("integracao", moduleIntegracao);
        moduleIntegracao.isRegistered = true;
      }
      this.getPaginas();
      console.log('Variavel',this.paginas)
    },
    computed: {
      currentStep() {
        return this.$store.state.integracao.step;
      },
      userisloged(){
        let user = localStorage.getItem('integracaoLogged')
        return JSON.parse(user);
      }
    },
    methods: {
      goToSlides(){
        this.$router.push({name:'integracao-slides',params:{id:1}})
      },
    },
    data(){
      return{
        paginaAtual:0,
        user:'Ana',
        paginas:[],
        backgroundLoading: '#ffffff',
      }
    }
  };
</script>

<style scoped>
  .boas-vindas{
    background-image: url('../../assets/images/novaintegracao/bg-boas-vindas.png') !important;
    background-size: cover;
    background-position: center;
  }
  .dourado{
    color: #F0A977 !important;
  }
  .btn-next{
    letter-spacing: 3px;
    background-color: #F0A977;
    width: 250px;
    height: 70px;
  }
</style>
